mutation PurchaseOrderRowProtection($input: PurchaseOrderRowProtectionInput!) {
  purchaseOrderRowProtection(input: $input) {
    secureRowLevel {
      id
      name
    }
  }
}
